import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { EMPTY_VALUE } from 'src/app/_helpers/utils';

/** What a badge column tells the renderer, through `cellRendererParams`. */
export type BadgeRendererParams<TData = unknown> =
  ICellRendererParams<TData> & {
    /** The `lty-badge` modifier for a row (`success`, `gray`…); empty draws it plain. */
    badgeClass?: (data: TData) => string;
  };

/**
 * The cell's value as an `lty-badge`, tinted per row. The column's value
 * getter supplies the label, as it would for a plain text cell, so copy and
 * export read the same thing the badge shows; a row without a value shows the
 * empty dash.
 */
@Component({
  selector: 'app-badge-renderer',
  standalone: true,
  template: `
    @if (label) {
      <span class="lty-badge {{ badgeClass }}">{{ label }}</span>
    } @else {
      {{ empty }}
    }
  `,
})
export class BadgeRendererComponent implements ICellRendererAngularComp {
  label = '';

  badgeClass = '';

  readonly empty = EMPTY_VALUE;

  agInit(params: BadgeRendererParams): void {
    const { value } = params;
    this.label =
      typeof value === 'string' && value !== EMPTY_VALUE ? value : '';
    this.badgeClass =
      this.label && params.data !== undefined && params.badgeClass
        ? params.badgeClass(params.data)
        : '';
  }

  refresh(): boolean {
    return false;
  }
}
